export var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["en"] = "en";
    SupportedLanguages["de"] = "de";
    SupportedLanguages["bg"] = "bg";
})(SupportedLanguages || (SupportedLanguages = {}));
export const supportedLanguages = Object.keys(SupportedLanguages);
const browserLang = window.navigator.userLanguage || window.navigator.language;
const currentLang = browserLang && browserLang.substr(0, 2);
const FALLBACK_LANG = supportedLanguages.includes(currentLang) ? currentLang : 'en';
export const loadLang = supportedLanguages.includes(window.localStorage.language) ? window.localStorage.language : FALLBACK_LANG;
export const i18nextConfig = {
    load: 'languageOnly',
    fallbackLng: ['en'],
    ns: ['default'],
    defaultNS: 'default',
    lng: loadLang,
    interpolation: {
        escapeValue: false,
    },
    returnEmptyString: false,
    backend: {
        queryStringParams: { v: RELEASE },
    },
};
export const languageOptions = [{
        value: SupportedLanguages.en,
        label: 'English',
    }, {
        value: SupportedLanguages.de,
        label: 'Deutsch',
    }, {
        value: SupportedLanguages.bg,
        label: 'български',
    }];
